const CONSTANTS = {
  STATUS_TYPES: {
    ACTIVE: true,
    INACTIVE: false,
  },
  EMAIL_STATUS: {
    SCHEDULED: 1,
    PENDING: 2,
    DELIVERED: 3,
    ERROR: 4,
  },
  CAMPAIGN_STATUS_TYPES: {
    ACTIVE: 1,
    INACTIVE: 2,
    ARCHIVED: 3,
  },
  CONTACT_PHONE_TYPES: {
    MOBILE: 3,
    WORK: 2,
    HOME: 1,
    // FAX: 4,
    DEFAULT: 5,
  },

  EMAIL_SERVICES: {
    MAILGUN: 1,
    CONSTANT_CONTACT: 3,
    SMTP: 4,
    DEFAULT_PROVIDER: 5,
  },

  EMAIL_TYPES: {
    MARKETING: "marketing",
    TRANSACTIONAL: "transactional",
  },

  // Mirrors email_addresses.disabled_reason. Null means a user disabled the
  // address; a value here means the platform did.
  EMAIL_DISABLED_REASONS: {
    MX_DOMAIN: "mx_domain",
  },

  // Mirrors mx_domains.validation_status, joined onto the address. Independent
  // of `enabled`: an invalid domain stays flagged on a re-enabled address.
  EMAIL_DOMAIN_STATUS: {
    INVALID: "invalid",
  },

  // Plain-language copy for each mx_domains.validation_status, shared by the
  // MX Domains table's badges and status filter.
  MX_DOMAIN_STATUSES: [
    {
      id: "valid",
      name: "Valid",
      description: "Accepts email.",
      badgeVariant: "success",
    },
    {
      id: "invalid",
      name: "Invalid",
      description:
        "No mail server found. Email addresses on this domain are disabled.",
      badgeVariant: "destructive",
    },
    {
      id: "pending",
      name: "Pending",
      description: "Not checked yet.",
      badgeVariant: "secondary",
    },
  ],

  TAG_COLORS: [
    "#8dd3c7",
    "#ffffb3",
    "#bebada",
    "#fb8072",
    "#80b1d3",
    "#fdb462",
    "#b3de69",
    "#fccde5",
    "#d9d9d9",
    "#bc80bd",
    "#ccebc5",
    "#ffed6f",
  ],

  HTTP_METHODS: [
    "get",
    "post",
    "put",
    "delete",
    "head",
    "connect",
    "options",
    "trace",
    "patch",
  ],

  DATA_JOB_STATUSES: {
    SCHEDULED: 1,
    IN_PROGRESS: 2,
    FAILED: 3,
    COMPLETE: 4,
    ABORTED: 5,
    READY: 6,
    EXPIRED: 7,
    COMPLETED_WITH_ERRORS: 8,
  },
  IMPORT_TYPES: {
    DATA: 1,
    AUDIT_LOGS: 2,
    CASE_DATA: 3,
  },
  EXPORT_TYPES: {
    CONTACTS: 1,
    AUDIT_LOGS: 2,
    CAMPAIGN_TARGETS: 3,
  },
  AUDIT_LOG_CATEGORIES: {
    USER: "user",
    ENTITY: "entity",
    CONTACT: "contact",
    DATA_JOB: "data_job",
    EMAIL: "email",
    FORM: "form",
    CALL: "call",
    MAIL: "mail",
    WEB: "web",
    MANUAL_UPDATE: "manual_update",
  },
  EMAIL_SUBCATEGORY: {
    DELIVERED: "email_delivered",
    OPENED: "email_opened",
    BOUNCED: "email_errored",
    CLICKED: "email_clicked",
  },
  FORM_SUBCATEGORY: {
    LOADED: "form_loaded",
    SAVED: "form_saved",
    SUBMITTED: "form_submitted",
  },
  MAIL_SUBCATEGORY: {
    SENT: "mail_mailed",
    DELIVERED: "mail_delivered",
  },
  WEB_SUBCATEGORY: {
    WEB: "visit",
  },
};

const TABS = [
  {
    name: "activityLog",
    icon: "clipboard list",
  },
  {
    name: "calls",
    icon: "phone",
  },
  {
    name: "campaigns",
    icon: "bullhorn",
  },
  {
    name: "events",
    icon: "bolt",
  },
  {
    name: "cases",
    icon: "folder open",
  },
  {
    name: "contacts",
    icon: "user outline",
  },
  {
    name: "contracts",
    icon: "handshake outline",
  },
  {
    name: "leads",
    icon: "address book outline",
  },
  {
    name: "departments",
    icon: "sitemap",
  },
  {
    name: "emailSchedules",
    icon: "mail",
  },
  {
    name: "notices",
    icon: "bell",
  },
  {
    name: "targetCompanies",
    icon: "crosshairs",
  },
  {
    name: "3rd_party_leads",
    icon: "user secret",
  },
  {
    name: "machines",
    icon: "server",
  },
  {
    name: "notes",
    icon: "sticky note outline",
  },
  {
    name: "responses",
    icon: "comments outline",
  },
  {
    name: "revenueOpportunities",
    icon: "gem outline",
  },
  {
    name: "script",
    icon: "file alternate outline",
  },
  {
    name: "survey",
    icon: "cube",
  },
  {
    name: "submittedForms",
    icon: "comments outline",
  },
  {
    name: "invoices",
    icon: "gem outline",
  },
];

const generateTabs = (...names) => {
  const tabNames = TABS.map(tab => tab.name);
  return names
    .filter(name => tabNames.includes(name))
    .map(name => TABS.find(tab => tab.name === name));
};

export const CALL_DISPOSITION_IDS = {
  CALLBACK: -1,
  SKIPPED: -2,
};

export const CALL_DISPOSITION_TYPES = {
  CALLBACK: "callback",
  CONNECTED: "connected",
  NOT_CONNECTED: "not_connected",
  SKIPPED: "skipped",
  VOICEMAIL: "voicemail",
  UNKNOWN: "unknown",
};

export const SYSTEM_ROLES = {
  ADMIN: -1,
};

export const FEATURE_FLAG_ACCESS_TYPE = {
  EVERYONE: 0,
  CUSTOM: 1,
};

// The self-referential flag that gates the feature-flag settings UI itself;
// mirrors the backend SYSTEM_SETTINGS_FLAG_KEY.
export const SYSTEM_SETTINGS_FLAG_KEY = "enable_ruvixx_flags_sys_settings";

export const TIME_UNITS = [
  // "seconds",
  // "minutes",
  "hours",
  "days",
  "weeks",
  "months",
  "years",
];

export const TIME_IN_MS = {
  DAY: 24 * 60 * 60 * 1000,
};

export const DEFAULT_CAMPAIGN_ID = 0;

export const EMAIL_URL_LANGS = {
  ENGLISH: "en",
  THAI: "th",
  JAPANESE: "ja",
};

export const EMAIL_SERVICES = CONSTANTS.EMAIL_SERVICES;

export const DEFAULT_PROVIDER = CONSTANTS.EMAIL_SERVICES.DEFAULT_PROVIDER;

export const DEFAULT_PROVIDER_OPTION = {
  key: DEFAULT_PROVIDER,
  text: "Campaign Default",
  value: DEFAULT_PROVIDER,
};

export const NULL_OPTION = {
  key: null,
  value: null,
  text: "None",
};

export const NULL_TEMPLATE = {
  id: null,
  name: "",
  subject: "",
  text: "",
  html: "",
  info: {},
};

export const DEFAULT_PAGE_SIZE = 50;
export const TABLE_PAGE_SIZES = [5, 10, 20, 25, 50, 100];
export const SELECT_COLUMN_ID = "select";

export const EPOCH_TIMESTAMP = "1970-01-01T00:00:00";
export const USER_ALERTS_FETCH_INTERVAL = 120000;

export const RANGE_FILTER = {
  GREATER_THAN: 1,
  LESS_THAN: 2,
  BETWEEN: 3,
  EQUALS: 4,
};

export const USER_STATUSES = {
  ONLINE: {
    key: "ONLINE",
    label: "Online",
  },
  OFFLINE: {
    key: "OFFLINE",
    label: "Offline",
  },
  DISCONNECTED: {
    key: "DISCONNECTED",
    label: "Disconnected",
  },
  DISABLED: {
    key: "DISABLED",
    label: "Disabled",
  },
  ON_CALL: {
    key: "ON_CALL",
    label: "On a call",
  },
};

export const TABLE_PAGE_CONTAINER_HEIGHT = {
  FILE_TAB: "calc(100vh - 146px)",
  ITEMS_TAB: "calc(100% - 47px)",
  ONLY_HEADER: "100vh",
};

export default CONSTANTS;
export { generateTabs };
